/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import EwaButton2 from "../../../../atoms/inputs/EwaButtons/EwaButton/EwaButton2";
import { useFormatMsg } from "../../../../../hooks/useFormatMsg";
import { acceptButtonCss, containerCss, declineButtonCss } from "./styles";

export type Props = {
  onAccept(): void;
  onDecline(): void;
  isAccepting?: boolean;
  className?: string;
};

const ConfirmationButtons: FC<Props> = ({
  onAccept,
  onDecline,
  className,
  isAccepting = false,
}) => {
  const formatMsg = useFormatMsg();

  return (
    <div css={containerCss} className={className}>
      <EwaButton2
        css={declineButtonCss}
        onClick={onDecline}
        iconName="close"
        label={formatMsg("common.decline")}
        dataCy="decline-button"
      />
      <EwaButton2
        css={acceptButtonCss}
        onClick={onAccept}
        isLoading={isAccepting}
        iconName="done"
        label={formatMsg("common.accept")}
        dataCy="accept-button"
      />
    </div>
  );
};

export default ConfirmationButtons;
export type ConfirmationButtonsProps = Props;
